import { GRN_TYPE } from './grnType';

export const REJECT_TYPE_OPTIONS = [
  { label: 'Shortage', value: 'shortage' },
  { label: 'Damage', value: 'damage' },
  { label: 'Other', value: 'other' },
];

export const getGrnRejectTypeBadgeColor = status => {
  switch (status) {
    case 'shortage':
      return 'warning';

    case 'damage':
      return 'danger';

    case 'other':
      return 'secondary';

    default:
      return 'secondary';
  }
};

export const getGrnTypeBadgeColor = type => {
  switch (type) {
    case GRN_TYPE.PURCHASE_ORDER:
      return 'primary';
    case GRN_TYPE.GATE_PASS:
      return 'danger';
    default:
      return 'secondary'; // Fallback for unknown types
  }
};
